const defaultBoxes = [];
const unassignedBoxes = (state = defaultBoxes, action) => {
  switch (action.type) {
    case 'EPIK_BOXES_CLEAR':
      return defaultBoxes;
    case 'EPIK_UNASSIGNED_BOXES_SUCCESS':
      return [...action.boxes];
    default:
      return state;
  }
};

export default unassignedBoxes;
